// extracted by mini-css-extract-plugin
module.exports = {"CheckBox":"CheckBox_CheckBox__13GtH"};